module.exports = __webpack_public_path__ + "img/outbreak-center.58f285dc.png";